<template><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.1633 21.9999C21.0817 21.9999 21.898 21.1836 21.898 20.2652V16.1836H17.2041V21.9999H20.1633Z" fill="white"/>
<path d="M22 9.04072H17.3062V14.857H22V9.04072Z" fill="white"/>
<path d="M20.1633 2H17.2041V7.91837H21.898V3.83673C22 2.81633 21.1837 2 20.1633 2Z" fill="white"/>
<path d="M16.0816 2H7.91836V21.898H16.0816V2Z" fill="white"/>
<path d="M2 20.1633C2 21.1837 2.81633 22 3.83673 22H6.79592V16.0817H2V20.1633Z" fill="white"/>
<path d="M6.69388 9.04072H2V14.857H6.69388V9.04072Z" fill="white"/>
<path d="M2 3.83673V7.91837H6.69388V2H3.83673C2.81633 2 2 2.81633 2 3.83673Z" fill="white"/>
</svg></template>
